import { Box, Divider, ListItemIcon, ListItemText, MenuItem, MenuList, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import PopularIcon from '@mui/icons-material/Stars';
import SnoopIcon from '@mui/icons-material/Diversity3';
import BrowseIcon from '@mui/icons-material/Warehouse';
import { useLocation, useNavigate } from 'react-router-dom';
import { RightMenu } from './RightMenu';

export const SideMenu = ({ mobile = false, onClick = () => {} }) => {

    const location = useLocation();
    const navigate = useNavigate();

    const theme = useTheme();
    const isCompact = useMediaQuery(theme.breakpoints.down('md'));

    const menuItems = [
        {
            label: "Snoop",
            navTo: 'activities',
            icon: <SnoopIcon />,
            selected: location.pathname.startsWith('/activities'),
        },
        {
            label: 'Popular',
            navTo: 'popular',
            icon: <PopularIcon />,
            selected: location.pathname.startsWith('/popular'),
        },
        {
            label: 'Browse',
            navTo: 'browse',
            icon: <BrowseIcon />,
            selected: location.pathname.startsWith('/browse'),
        },
    ];
    // if (user) {
    //     menuItems.push();
    // }

    const handleMenuClick = menu => {
        navigate(`/${menu}`);
        onClick();
    }

    return (
        <Box sx={{ display: { xs: mobile ? 'flex' : 'none', sm: 'flex' }, p: 1, flexDirection: 'column', width: mobile ? '320px' : '100%' }}>
            <MenuList sx={{
                color: 'appShell.chromeText',
                '& .MuiListItemIcon-root': {
                    color: 'appShell.chromeText',
                },
                '& .MuiMenuItem-root': {
                    borderRadius: '8px',
                    mb: '4px',
                },
                '& .MuiMenuItem-root:hover': {
                    backgroundColor: 'rgba(255, 242, 223, 0.08)',
                },
                '& .Mui-selected, & .Mui-selected:hover': {
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                },
                '& .Mui-selected .MuiListItemIcon-root': {
                    color: 'primary.contrastText',
                },
            }}>
                {menuItems.map(mi => {
                    return (
                        <MenuItem key={mi.navTo} onClick={() => handleMenuClick(mi.navTo)} selected={mi.selected}>
                            {mobile || !isCompact ? <ListItemText>{mi.label}</ListItemText> : null}
                            <Tooltip
                                title={mi.label}
                                disableHoverListener={!isCompact}
                                disableFocusListener={!isCompact}
                                placement='right'
                            >
                                <ListItemIcon>{mi.icon}</ListItemIcon>
                            </Tooltip>
                        </MenuItem>
                    );
                })}
            </MenuList>
            {mobile ?
                <>
                    <Divider />
                    <RightMenu />
                </>
            : null}
        </Box>
    );
}
